import { useState } from 'react';
import translator from '@Components/Utilities/Translator';
import LoadingRing from '@Components/MuiWrappers/LoadingRing';
import Modal from '@Components/Shared/Modals/Modal';
import { setCookie } from '../Components/Utilities/CookieHelper';


const RegionMapView = (props) => {

    const [display, setDisplay] = useState(props.DisplayMap);
    const [showSpinner, setShowSpinner] = useState(false);

    const HandleEvent = (url) => {
        setRegionMapHistoryCookie();
        if (url) {
            setShowSpinner(true);
            window.location = url;
        }

        setDisplay(display => !display);
    };

    const setRegionMapHistoryCookie = () => {
        let date = new Date;
        date.setTime(date.getTime() + 24 * 60 * 60 * 1000 * 365);
        let expiresOn = date.toUTCString();
        setCookie('MapHistory', 'set=true', expiresOn);
    }

    return (
        <>
            {display &&
                <Modal containerClassName='region-map-modal'>
                    <Modal.Header onClose={() => HandleEvent()}>
                        <img src={props.PublicationLogo} alt={props.PublicationLogoAltText} />
                        <Modal.Title>{translator.translate('sandhills.tradepubwebsite.mvc.selectyourlocations')}</Modal.Title>
                        <div className='info'>{translator.translate('sandhills.whyamiseeingthis')} <i className='fas fa-info-circle' />
                            <div className='tooltip'>{props.ExplanationText}</div>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='location-selector'>
                            {props.Locations.map((item) =>
                                <a key={props.ClassName} className='location'>
                                    <img role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); HandleEvent(item.RedirectUrl); } }} src={item.ImageUrl} alt="" onClick={() => HandleEvent(item.RedirectUrl)} />
                                    {item.DisplayName}
                                </a >)
                            }
                        </div>
                    </Modal.Body>
                </Modal>}
            {showSpinner && <LoadingRing backdrop />}
        </>
    );
};

export default RegionMapView;
global.RegionMapView = RegionMapView;